import { FuncoesCriptografia } from './Funcoes-criptografia';


export class StorafeUtil<T, K> {


  public static gravaSessionStorage(T, K): void {
    sessionStorage.removeItem(T);
    const objetoParseJson = JSON.stringify(K);
    sessionStorage.setItem(T, FuncoesCriptografia.criptografiaAvancada(objetoParseJson));
  }


  public static recuperarSessionStorage(T): string {
    const retornoObjeto = FuncoesCriptografia.descriptografiaAvancada(sessionStorage.getItem(T));
    return retornoObjeto;
  }

  public static limparSessionStorage(T): void {
    if (T) { sessionStorage.removeItem(T) };
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/storasge.util.ts